import { TypedDocumentNode, gql } from '@apollo/client';
import { useParams } from 'react-router-dom';

import { PullToRefetch } from '@sorare/core/src/atoms/navigation/PullToRefetch';
import {
  NBA_LIVE_PRO_GAMES_ID,
  NBA_PLAY_PRO_GAMES_ID,
} from '@sorare/core/src/constants/__generated__/routes';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';
import { useIsRemovingMyLineupsUS } from '@sorare/core/src/hooks/navigation/useIsRemovingMyLineupsUS';

// fixme location
import { LiveGameSelectionView } from 'components/live/LiveGameSelectionView';

import {
  NBALiveGamesQuery,
  NBALiveGamesQueryVariables,
} from './__generated__/index.graphql';

const query = gql`
  query NBALiveGamesQuery($fixtureSlug: String!) {
    nbaFixture(slug: $fixtureSlug) {
      slug
      ...LiveGameSelectionView_NBAFixture
    }
  }
  ${LiveGameSelectionView.fragments.NBAFixture}
` as TypedDocumentNode<NBALiveGamesQuery, NBALiveGamesQueryVariables>;

type Props = {
  currentFixture: {
    slug: string;
  };
};
export const LiveProGamesPage = ({ currentFixture }: Props) => {
  const useRemoveMyLineups = useIsRemovingMyLineupsUS();
  const { id } = useParams();
  const { data, loading, refetch } = useQuery(query, {
    variables: {
      fixtureSlug: currentFixture?.slug || '',
    },
    skip: !currentFixture?.slug,
  });

  if (!data || !currentFixture || (!data && loading)) {
    return null;
  }
  return (
    <PullToRefetch refetch={refetch}>
      <LiveGameSelectionView
        currentFixture={data.nbaFixture}
        gameIdFromRouteParams={id}
        liveGameIdRoute={
          useRemoveMyLineups ? NBA_PLAY_PRO_GAMES_ID : NBA_LIVE_PRO_GAMES_ID
        }
      />
    </PullToRefetch>
  );
};
